export const formatFirstName = (firstname: any) => {
    if(typeof firstname == 'string')
        return firstname.charAt(0).toUpperCase() + firstname.slice(1);
    else
        return ''
}